export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';

// state and market action types
export const SET_SELECTED_STATE = 'SET_SELECTED_STATE';
export const SET_SELECTED_MARKET = 'SET_SELECTED_MARKET';

// Top level taxonomy state action types
export const REQUEST_TOP_LEVEL_TAXONOMY_DATA = 'REQUEST_TOP_LEVEL_TAXONOMY_DATA';
export const RECEIVE_TOP_LEVEL_TAXONOMY_DATA = 'RECEIVE_TOP_LEVEL_TAXONOMY_DATA';
export const TOP_LEVEL_TAXONOMY_SERVICE_ERROR = 'TOP_LEVEL_TAXONOMY_SERVICE_ERROR';

// next level taxonomy state action types
export const REQUEST_NEXT_LEVEL_TAXONOMY_DATA = 'REQUEST_NEXT_LEVEL_TAXONOMY_DATA';
export const RECEIVE_NEXT_LEVEL_TAXONOMY_DATA = 'RECEIVE_NEXT_LEVEL_TAXONOMY_DATA';
export const NEXT_LEVEL_TAXONOMY_SERVICE_ERROR = 'NEXT_LEVEL_TAXONOMY_SERVICE_ERROR';
export const SET_PARENT_IN_NEXT_LEVEL_TAXONOMY = 'SET_PARENT_IN_NEXT_LEVEL_TAXONOMY';
export const ADD_STATE_IN_PAGE_STACK = 'ADD_STATE_IN_PAGE_STACK';
export const REMOVE_STATE_IN_PAGE_STACK = 'REMOVE_STATE_IN_PAGE_STACK';

// file downloading progress popup
export const SHOW_FILE_PROGRESS_POPUP = 'SHOW_FILE_PROGRESS_POPUP';
export const HIDE_FILE_PROGRESS_POPUP = 'HIDE_FILE_PROGRESS_POPUP';

//newUI
export const SET_FAVORITES_LIST = 'SET_FAVORITES_LIST';
